module.exports = __webpack_public_path__ + "img/big-icon-discount-incomplete.26655a34.svg";